import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=ff3384b0&scoped=true&"
import script from "./Players.vue?vue&type=script&lang=ts&"
export * from "./Players.vue?vue&type=script&lang=ts&"
import style0 from "./Players.vue?vue&type=style&index=0&id=ff3384b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3384b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
